import { render, staticRenderFns } from "./RedirectToV3.vue?vue&type=template&id=fd70ad3a"
import script from "./RedirectToV3.vue?vue&type=script&lang=js"
export * from "./RedirectToV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports